import React from 'react';
import { Modal, IconButton } from '@mui/material';
import { QrReader } from 'react-qr-reader';
import CloseIcon from '@mui/icons-material/Close';

// Styles
import { useStyles } from './QrReaderWindowStyles';

const QrReaderWindow = ({
  isQrOpen,
  handleError,
  handleScan,
  toggleQrOpen,
}) => {
  const { classes } = useStyles();

  return (
    <Modal open={isQrOpen} onClose={toggleQrOpen}>
      <div className={classes.root}>
        <IconButton className={classes.closeButton} onClick={toggleQrOpen}>
          <CloseIcon />
        </IconButton>
        <QrReader
          className={classes.qrReaderContainer}
          onResult={(result, error) => {
            if (!!result) {
              handleScan(result);
            }
            if (!!error) {
              handleError(error);
            }
          }}
          constraints={{
            facingMode: 'environment',
            aspectRatio: { ideal: 1 },
          }}
          containerStyle={{ width: '100%', height: '100vh' }}
          ViewFinder={ViewFinder}
        />
      </div>
    </Modal>
  );
};

export default QrReaderWindow;

const ViewFinder = () => {
  const { classes } = useStyles();
  return (
    <>
      <svg width="50px" viewBox="0 0 100 100" className={classes.overlay} />
      <p className={classes.resultText}>
        Align the QR code within the frame to scan
      </p>
    </>
  );
};
